import { QuyDoiDonViTinhChung } from '@/types/schemas/quy-doi-don-vi-tinh-chung.type';
import { AritoIcon, Button, DialogV2 } from '@/components/custom/erp';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: QuyDoiDonViTinhChung | null;
  deleteUnit: (uuid: string) => Promise<void>;
  clearSelection: () => void;
}

export const DeleteDialog = ({ onClose, open, selectedObj, deleteUnit, clearSelection }: DeleteDialogProps) => {
  const handleDelete = async () => {
    if (selectedObj) {
      try {
        await deleteUnit(selectedObj.uuid);
        clearSelection();
        onClose();
      } catch (error) {
        console.error('Error deleting Unit:', error);
      }
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xóa dữ liệu'
      maxWidth='sm'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]' onClick={handleDelete}>
            <AritoIcon icon={884} marginX='4px' />
            Đồng ý
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} marginX='4px' />
            Huỷ
          </Button>
        </>
      }
    >
      <p className='min-w-[30vw] p-4 text-base font-medium'>Bạn có chắc chắn xóa không?</p>
    </DialogV2>
  );
};

export default DeleteDialog;
